import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {
  ConservazioneCaricaDocumentoBilanciStep2Component
} from './conservazione-carica-documento-bilanci-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-bilanci-step2', {
            url: '/conservazione-carica-bilanci',
            ncyBreadcrumb: {
                label: 'Carica Bilanci',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-bilanci-step2 flex="100"></conservazione-carica-documento-bilanci-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoBilanciStep2Module: string = ng
    .module('conservazione-carica-documento-bilanci-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoBilanciStep2', ConservazioneCaricaDocumentoBilanciStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-bilanci-step2/conservazione-carica-documento-bilanci-step2.module.ts